import React from 'react';

const Object_this = () => {
  return (
    <div >
      <h1>Object_this</h1>
      <p>Placeholder component for: "Object this"</p>
    </div>
  );
};

export default Object_this;
